export function ArrayComparator(arr1, arr2) {

    let base_data = {}
    let new_data = {}

    let guids_arr1 = []
    let guids_arr2 = []

    let inserted = []
    let updated = []
    let deleted = []


    arr1.map(el => {
        base_data[el.__ID] = el
        guids_arr1.push(el.__ID)
    })
    arr2.map(el => {
        new_data[el.__ID] = el
        guids_arr2.push(el.__ID)
    })

    guids_arr1.map(el => {
        if (guids_arr2.includes(el)) {
            let el1 = base_data[el]
            let el2 = new_data[el]
            let el_keys
            if (el1) {
                el_keys  = Object.keys(el1)
            } else {
                el_keys  = Object.keys(el2)
            }

            el_keys.map(field => {
                if (el1[field] !== el2[field]) {
                    updated.push(new_data[el])
                    return true
                }
                return false
            })
        } else {
            deleted.push(base_data[el])
        }
    })

    guids_arr2.map(el => {
        if (!guids_arr1.includes(el)) {
            inserted.push(new_data[el])
        }
    })

    return {
        inserted: inserted,
        updated: updated,
        deleted: deleted
    }
}
